<template>
  <div
    class="custom-header"
    @mouseover="onMouseOver"
    @click="onHeaderClick"
    @mouseleave="onMouseLeave"
  >
    <!-- カラム名-->
    <span class="column">
      <img
        v-show="filteringState === 'hover' && isSortable"
        class="horizontal-line"
        :src="horizontalLineHover"
      />
      <img
        v-show="filteringState === 'filtered/hover' && isSortable"
        class="horizontal-line"
        :src="horizontalLineFilteredHover"
      />
      <vx-tooltip :text="headerName" position="top">
        <span class="header-name" :style="presentTextStyle">
          {{ headerName }}
        </span>
      </vx-tooltip>
    </span>
    <img
      v-show="isShowIcon"
      ref="filterButton"
      :style="iconStyle"
      :src="presentIconImg"
      @mousedown.stop.prevent="onIconClick"
      @click.stop.prevent=""
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("gkmgPortMasterDestinationWork");
import { COL_NAME } from "@/config/const.js";
const sortableColumns = COL_NAME.filter((column) => column.sortable);
const sortableColumnKeys = new Set(
  sortableColumns.map((column) => column.columnKey),
);

export default {
  data() {
    return {
      downPointDefault: require("@/assets/images/icons/gkmg-port-master/down_point_default.svg"),
      downPointHover: require("@/assets/images/icons/gkmg-port-master/down_point_hover.svg"),
      downPointSelect: require("@/assets/images/icons/gkmg-port-master/down_point_select.svg"),
      downPointFilteredDefault: require("@/assets/images/icons/gkmg-port-master/down_point_filtered_default.svg"),
      downPointFilteredHover: require("@/assets/images/icons/gkmg-port-master/down_point_filtered_hover.svg"),
      downPointFilteredSelect: require("@/assets/images/icons/gkmg-port-master/down_point_filtered_select.svg"),
      horizontalLineHover: require("@/assets/images/icons/gkmg-port-master/horizontal_line_hover.svg"),
      horizontalLineFilteredHover: require("@/assets/images/icons/gkmg-port-master/horizontal_line_filtered_hover.svg"),
    };
  },
  computed: {
    ...mapGetters({
      presentColumnsFilteringState: "presentColumnsFilteringState",
    }),
    headerName() {
      return this.params.column.colDef.headerName;
    },
    columnKey() {
      return this.params.column.colDef.field;
    },
    textHeaderWidth() {
      return this.params.column.actualWidth - this.iconWidth;
    },
    filteringState() {
      return this.presentColumnsFilteringState[this.columnKey];
    },
    iconWidth() {
      return 24; // px
    },
    iconStyle() {
      return {
        marginLeft: "auto",
        width: `${this.iconWidth}px`,
        paddingRight: "10px",
      };
    },
    textStyleDefault() {
      return {
        backgroundColor: "#1B1B1B",
        color: "#BDBDBD",
        paddingLeft: `${Math.floor(this.textHeaderWidth / 8)}px`,
      };
    },
    textStyleHover() {
      return {
        backgroundColor: "#4F4F4F",
        color: "#BDBDBD",
        paddingLeft: `${Math.floor(this.textHeaderWidth / 8)}px`,
      };
    },
    textStyleSelect() {
      return {
        backgroundColor: "#4F4F4F",
        color: "#BDBDBD",
        paddingLeft: `${Math.floor(this.textHeaderWidth / 8)}px`,
      };
    },
    textStyleFilteredDefault() {
      return {
        backgroundColor: "#1B1B1B",
        color: "#BDBDBD",
        paddingLeft: `${Math.floor(this.textHeaderWidth / 8)}px`,
      };
    },
    textStyleFilteredHover() {
      return {
        backgroundColor: "#4F4F4F",
        color: "#BDBDBD",
        paddingLeft: `${Math.floor(this.textHeaderWidth / 8)}px`,
      };
    },
    textStyleFilteredSelect() {
      return {
        backgroundColor: "#4F4F4F",
        color: "#BDBDBD",
        paddingLeft: `${Math.floor(this.textHeaderWidth / 8)}px`,
      };
    },
    isShowIcon() {
      return this.params.column.colDef.filterable;
    },
    presentTextStyle() {
      return this.applyStyleToHeaders(this.filteringState);
    },
    presentIconImg() {
      return this.applyFilterButtonIconSource(this.filteringState);
    },
    isSortable() {
      const isSortable = sortableColumnKeys.has(this.columnKey);
      return isSortable;
    },
  },
  methods: {
    onIconClick() {
      const sourceElement = this.$refs.filterButton;
      this.params.showColumnMenu(sourceElement);
      this.params.context.componentParent.updateFilterState(
        this.columnKey,
        false,
        true,
      );
    },
    onHeaderClick() {
      this.params.context.componentParent.updateFilterState(
        this.columnKey,
        false,
        true,
      );
    },
    onMouseOver() {
      if (this.filteringState === "select") {
        this.params.context.componentParent.updateFilterState(
          this.columnKey,
          false,
          true,
        );
      } else {
        this.params.context.componentParent.updateFilterState(
          this.columnKey,
          true,
          false,
        );
      }
    },
    onMouseLeave() {
      if (["select", "filtered/select"].includes(this.filteringState)) {
        this.params.context.componentParent.updateFilterState(
          this.columnKey,
          false,
          true,
        );
      } else {
        this.params.context.componentParent.updateFilterState(
          this.columnKey,
          false,
          false,
        );
      }
    },
    /**
     * カラムのフィルター状態に応じたアイコンを指定する。
     */
    applyFilterButtonIconSource(filteringState) {
      const mapper = {
        default: this.downPointDefault,
        hover: this.downPointHover,
        select: this.downPointSelect,
        "filtered/default": this.downPointFilteredDefault,
        "filtered/hover": this.downPointFilteredHover,
        "filtered/select": this.downPointFilteredSelect,
      };
      const icon = mapper[filteringState]
        ? mapper[filteringState]
        : this.downPointDefault;
      return icon;
    },
    /**
     * カラムのフィルター状態に応じたCSSスタイルを指定する。
     */
    applyStyleToHeaders(filteringState) {
      const mapper = {
        default: this.styleDefault,
        hover: this.styleHover,
        select: this.styleSelect,
        "filtered/default": this.styleFilteredDefault,
        "filtered/hover": this.styleFilteredHover,
        "filtered/select": this.styleFilteredSelect,
      };
      const style = mapper[filteringState]
        ? mapper[filteringState]
        : this.styleDefault;
      return style;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-header {
  display: flex;
  align-items: center;
  text-align: flex-end;
  width: 100%;
}
.column {
  display: flex;
  flex-direction: column;
  height: 30px;
  max-width: 10px;
}
.header-name {
  position: absolute;
  top: 10px;
  max-width: calc(100% - 24px);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.horizontal-line {
  margin: 3px 3px 3px 3px;
  width: 10px;
  height: 5px;
  cursor: grab;
}
</style>
